import { useState } from "react";
import { getthirdpartyData } from "V2.0/services/thirdpartyService";

function useCommunicationChannel({ workspaceId }) {
  const [communicationChannel, setCommunicationChannel] = useState({
    phoneNumbers: [],
  });

  const fetchCommunicationChannels = async () => {
    try {
      const response = await getthirdpartyData(workspaceId);
      if (response.status === 200) {
        const { telephonySettings } = response.data;
        if (telephonySettings.telephonyProvider === "twilio") {
          setCommunicationChannel({
            phoneNumbers: telephonySettings.twilioSettings.phoneNumbers,
          });
        }

        if (telephonySettings.telephonyProvider === "plivo") {
          setCommunicationChannel({
            phoneNumbers: telephonySettings.plivoSettings.phoneNumbers,
          });
        }

        if (telephonySettings.telephonyProvider === "mcube") {
          setCommunicationChannel({
            phoneNumbers: telephonySettings.mcubeSettings.phoneNumbers,
          });
        }

        if (telephonySettings.telephonyProvider === "cloudonix") {
          setCommunicationChannel({
            phoneNumbers: telephonySettings.cloudonixSettings.phoneNumbers,
          });
        }

        if (telephonySettings.telephonyProvider === "livekit") {
          setCommunicationChannel({
            phoneNumbers: telephonySettings.livekitSettings.phoneNumbers,
          });
        }

        if (telephonySettings.telephonyProvider === "tata") {
          setCommunicationChannel({
            phoneNumbers: Object.keys(
              telephonySettings.tataSmartFloSettings.phoneNumbersAndAuth
            ),
          });
        }

        if (telephonySettings.telephonyProvider === "exotel") {
          setCommunicationChannel({
            phoneNumbers: telephonySettings.exotelSettings.phoneNumbers,
          });
        }

        if (telephonySettings.telephonyProvider === "ozonetelcustomwebsocket") {
          const { phoneNumbers, inboundPhoneNumbers } =
            telephonySettings.ozonetelCustomWebsocketSettings;

          setCommunicationChannel({
            phoneNumbers: [...phoneNumbers, ...inboundPhoneNumbers],
          });
        }

        if (telephonySettings.telephonyProvider === "czentrix") {
          const { phoneNumbers } = telephonySettings.cZentrixSettings;

          setCommunicationChannel({
            phoneNumbers,
          });
        }
      }
    } catch (e) {
      console.error("Error getting third party data");
    }
  };

  return {
    communicationChannel,
    fetchCommunicationChannels,
  };
}

export { useCommunicationChannel };
